import React, { FC } from 'react'
import { InputComponentDefault } from './Default'
import { InputComponentDate } from './Date'
import { InputComponentPhone } from './Phone'
import { Wrapper, Error, Help, IconWrapper, InputWrapper } from './styled'

// TODO: add interface
export const InputComponent: FC<any> = ({
	input = 'default',
	error,
	help,
	className,
	icon,
	onClickHelp = null,
	...props
}) => {
	const inputChoise = () => {
		switch (input) {
			case 'phone':
				return <InputComponentPhone {...props} />
			case 'date':
				return <InputComponentDate {...props} />
			default:
				return <InputComponentDefault {...props} />
		}
	}
	return (
		<Wrapper className={className}>
			<InputWrapper>
				{inputChoise()}
				{icon && <IconWrapper>{icon}</IconWrapper>}
			</InputWrapper>
			{error && <Error>{error}</Error>}
			{help && (
				<Help onClick={onClickHelp} isGreen={Boolean(onClickHelp)}>
					{help}
				</Help>
			)}
		</Wrapper>
	)
}
